import { Component } from 'react';

/**
 * Last-resort error boundary. Unexpected render errors are logged with the
 * current path (never the query string) so they can be found in browser logs;
 * there is no external crash-reporting vendor configured yet — see
 * docs/activation-phase-1.md "Remaining known issues".
 */
export default class AppErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        try {
            console.error(JSON.stringify({
                level: 'error',
                kind: 'react_render_error',
                path: window.location.pathname,
                message: error?.message,
                stack: error?.stack,
                componentStack: info?.componentStack,
            }));
        } catch {
            console.error('[AppErrorBoundary]', error);
        }
    }

    render() {
        if (!this.state.error) return this.props.children;
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, textAlign: 'center', fontFamily: 'inherit' }}>
                <div>
                    <h1 style={{ fontSize: 22, marginBottom: 8 }}>Something went wrong</h1>
                    <p style={{ opacity: 0.7, marginBottom: 20 }}>Reload the page to keep going. Nothing you earned is lost.</p>
                    <button onClick={() => window.location.reload()} style={{ padding: '12px 24px', borderRadius: 12, border: 'none', background: '#f5c518', fontWeight: 700, cursor: 'pointer' }}>
                        Reload
                    </button>
                </div>
            </div>
        );
    }
}
